import { Line } from '@react-three/drei'
import { useMemo } from 'react'
import type { EixoColuna } from '../../dominio/geometria/anguloExtracao'
import { paraArray } from '../../dominio/geometria/vetor3'
import { pontosDaTrajetoria, type OpcoesRota, type RotaExtracao } from '../../dominio/didatico/rotasExtracao'
import { CORES_SEMANTICAS } from '../../dominio/didatico/tokens'
import { Rotulo3D } from '../componentes/Rotulo3D'

interface Props {
  rota: RotaExtracao
  eixoColuna: EixoColuna
  cor?: string
  rotulo?: string
  mostrarPontoSaida?: boolean
  /** as mesmas opções da amostragem, para a linha acompanhar o corpo */
  opcoes?: OpcoesRota
}

/** Rota de retirada: linha completa da trajetória e marcação do ponto de saída. */
export function TrajetoriaExtracao({
  rota,
  eixoColuna,
  cor = CORES_SEMANTICAS.trajetoria,
  rotulo,
  mostrarPontoSaida = true,
  opcoes = {},
}: Props) {
  const pontos = useMemo(
    () => pontosDaTrajetoria(rota, eixoColuna, 44, opcoes),
    [rota, eixoColuna, opcoes],
  )
  const chegada = pontos[pontos.length - 1]!

  return (
    <group>
      <Line points={pontos.map(paraArray)} color={cor} lineWidth={5} />
      {mostrarPontoSaida && (
        <>
          <mesh position={paraArray(chegada)}>
            <sphereGeometry args={[0.09, 16, 12]} />
            <meshStandardMaterial color={cor} emissive={cor} emissiveIntensity={0.5} />
          </mesh>
          {/* marca no piso, para o ponto de saída ser legível em qualquer órbita */}
          <mesh position={[rota.pontoSaida.x, 0.01, rota.pontoSaida.z]} rotation={[-Math.PI / 2, 0, 0]}>
            <ringGeometry args={[0.2, 0.26, 28]} />
            <meshBasicMaterial color={cor} transparent opacity={0.65} side={2} />
          </mesh>
        </>
      )}
      {rotulo && (
        <Rotulo3D
          posicao={{ x: chegada.x, y: chegada.y + 0.3, z: chegada.z }}
          texto={rotulo}
          variante="trajetoria"
          fator={4.5}
          sempreVisivel
        />
      )}
    </group>
  )
}
